'use strict';

var callBound = require('call-bind/callBound');
var $byteLength = callBound('ArrayBuffer.prototype.byteLength', true);

var isArrayBuffer = require('is-array-buffer');

/** @type {import('.')} */
module.exports = function byteLength(ab) {
	if (!isArrayBuffer(ab)) {
		return NaN;
	}
	return $byteLength ? $byteLength(ab) : ab.byteLength;
}; // in node < 0.11, byteLength is an own nonconfigurable property



//////////////////
// WEBPACK FOOTER
// ./~/array-buffer-byte-length/index.js
// module id = 61
// module chunks = 20216485166878 72576805601409 114276838955818 211741474912242 256957939565513